import MyFuneral from './MyFuneral'

export default MyFuneral
